import React from "react";
import Masthead, {
  MastheadMenuButton,
  MastheadTitle,
} from "@amzn/meridian/masthead";
import whsLogo from "src/images/WHS-Logo_Standard_Color.png";
import "./header.scss";
import { Icon, Row, Text } from "@amzn/meridian";
import { useAppDispatch } from "src/store/store";
import { toggleSideMenu, setProfileSheetOpen } from "src/store/uiSlice";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import { useNavigate } from "react-router-dom";

const header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  return (
    <Masthead>
      <Row width={"100%"} alignmentHorizontal="justify">
        <Row>
          <MastheadMenuButton onClick={() => dispatch(toggleSideMenu())} />
          <MastheadTitle onClick={() => navigate("/")}>
            <Row spacing={"200"} alignmentVertical="center">
              <Text type="h300" fontFamily="bookerly" className="saige-logo">
                SAIGE
              </Text>
              <Row height={16} width={0.85} backgroundColor="#5A5A5A" />
              <img
                src={whsLogo}
                alt="WHS logo"
                height={24}
                className="whs-logo"
              />
            </Row>
          </MastheadTitle>
        </Row>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => dispatch(setProfileSheetOpen(true))}
        >
          <Icon tokens={userTokens} />
        </div>
      </Row>
    </Masthead>
  );
};
export default header;
